import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "../../commons/components/Loading";
import { GET_PRODUCT_SURPLUS_URL } from "../../commons/constants/api-urls";
import useFetch from "../../commons/hooks/useFetch";
import { AppContext } from "../../contexts/AppContext";
import NotFoundPage from "../NotFound";
import CreateUpdateSurplusProductForm from "../../components/Form/CreateUpdateSurplusProductForm/CreateUpdateSurplusProductForm";
import { parseDataFromDetailToStandardVariableData } from "../../commons/utils/functions/surplusMapping";

const CreateUpdateSurplusProductPage: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId, surplusId } = useParams<{ storeId: string; surplusId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  const { data, loading } = useFetch<SurplusDataFromApi>(
    storeId && surplusId ? GET_PRODUCT_SURPLUS_URL(storeId, surplusId) : ""
  );
  if (loading) return <Loading />;

  if (surplusId && String(data?.id) !== surplusId) return <NotFoundPage />;

  return <CreateUpdateSurplusProductForm surplus={parseDataFromDetailToStandardVariableData(data)} />;
};

export default CreateUpdateSurplusProductPage;
